import { baseSchema, Update } from './base'
import { generate } from './generate'
import { z } from 'zod'

export const sdkVersionSchema = baseSchema.extend({
  createdAt: z.string(),
  commitId: z.string(),
  packageName: z.string(),
  packageVersion: z.string(),
  status: z.union([
    z.literal('published'),
    z.literal('publishing'),
    z.literal('error'),
  ]),
  exampleCode: z.string().nullable(),
})

export type SdkVersion = z.infer<typeof sdkVersionSchema>
export type SdkVersionUpdate = Update<SdkVersion>

export const sdkVersionBaseOps = generate('sdk-version', sdkVersionSchema.parse)
